import {notify} from '~/redux/ui/slice';
import {AppDispatch} from '~/redux/root-store';
import {useCallback} from 'react';

export function useNotification(dispatch: AppDispatch) {
  const addMessage = useCallback(
    (message: string, type: 'error' | 'success' | undefined = undefined) => {
      if (type === 'error' && !message) {
        message = 'Something went wrong!';
      }
      dispatch(notify({message, type}));
      setTimeout(() => {
        dispatch(notify({type, message: ''}));
      }, 1000);
    },
    [dispatch],
  );

  return {addMessage};
}
